module.exports = __webpack_public_path__ + "static/media/lipeeh_assis.d6091408.jpg";